import React from 'react';
import {
    List,
    Space,
    Drawer,
    message,
    Menu,
} from 'antd';
import HXOrderForm from './LZHXOrderForm';
import './LZHXOrderList.css';
import axios from 'axios';
import qs from 'qs';

// const baseUrl = "https://47.100.83.180/laizeAdmin";
// const baseUrl = "http://localhost:8080/laizeAdmin";
const baseUrl = "https://www.laizekeji.cn/laizeAdmin";

class LZHXOrderList extends React.Component {
    constructor(props) {
        super(props);

        this.state = { 
            isLoading: false, 
            visible: false, 
            originOrderList: [], 
            data: [], 
            orderDetail: {}, 
            selectedKeys:["全部"]
        };
        this.showDrawer = this.showDrawer.bind(this);
        this.onClose = this.onClose.bind(this);
        this.fetchOrderListWithIMId = this.fetchOrderListWithIMId.bind(this);
        this.switchTab = this.switchTab.bind(this);
    }

    componentDidMount() {
        this.HXIMID = getQueryVariable("visitorImId") || "";
        this.fetchOrderListWithIMId(this.HXIMID, 1);
    }

    showDrawer (index) {
        const _this=this;
        this.setState({
            isLoading: true,
        })

        let detail = {};
        if (index < this.state.originOrderList.length) {
            detail = this.state.originOrderList[index];
        }
        
        axios.post(baseUrl + '/hxcomponent/getOrderDetailById', qs.stringify({
            id: detail.id||""
        }))
            .then(function (res) {
                console.log(res.data);
                _this.setState({
                    isLoading: false,
                    orderDetail: res.data || {},
                    visible: true
                });
            })
            .catch(function (error){
                console.log(error);
                _this.setState({
                    isLoading: false,
                });
            });
    };

    onClose () {
        this.setState({
            visible: false,
            orderDetail: {}
        });
    };

    fetchOrderListWithIMId (IMId, orderType) {
        if (IMId === "") {
            console.log("环信ID不能为空");
            message.info('环信ID不能为空', 1);
            return;
        }

        const _this=this;
        this.setState({
            isLoading: true,
        })
        
        axios.post(baseUrl + '/hxcomponent/listOrders', qs.stringify({
            emchatId: IMId || "",
            orderType: orderType || 1,
            page: 1,
            size: 99999,
        }))
            .then(function (res) {
                let list = res.data.data || [];
                let data = list.map(function (item, index) {
                    return {
                        createTime: item.createTime || "无",
                        status: item.status || "无",
                        index: index,
                    };
                });

                _this.setState({
                    isLoading: false,
                    originOrderList: list,
                    data: data
                });
            })
            .catch(function (error){
                console.log(error);
                _this.setState({
                    isLoading: false,
                });
            });
    }

    switchTab(item) {
        if (item.key === this.state.selectedKeys[0]) {
            return;
        }

        this.setState({
            selectedKeys:[item.key]
        });

        let orderType = 1;
        if (item.key === "全部") {
            orderType = 1;
        } else if (item.key === "待付款") {
            orderType = 2;
        } else if (item.key === "待收货") {
            orderType = 3;
        } else {
            orderType = 4;
        }
        this.fetchOrderListWithIMId(this.HXIMID, orderType);
    }

    render() {
        return (
            <>
                <Menu onClick={this.switchTab} selectedKeys={this.state.selectedKeys} mode="horizontal">
                    <Menu.Item key="全部">
                    全部
                    </Menu.Item>
                    <Menu.Item key="待付款">
                    待付款
                    </Menu.Item>
                    <Menu.Item key="待收货">
                    待收货
                    </Menu.Item>
                    <Menu.Item key="已完成">
                    已完成
                    </Menu.Item>
                </Menu>
                <List
                    itemLayout="horizontal"
                    size="small"
                    split={true}
                    pagination={true}
                    dataSource={this.state.data}
                    renderItem={item => (
                        <List.Item key={item.createTime} actions={[<a onClick={()=>this.showDrawer(item.index)} >详情</a>]} >
                            <Space>
                                <div style={{backgroundColor:fetchColorHexForOrderStatus(item.status), color:'#ffffff'}}>{item.status||"无"}</div>
                                <div>{item.createTime||"无"}</div>
                            </Space>
                        </List.Item>
                    )}
                />
                <Drawer
                    title="订单详情"
                    placement="right"
                    closable={false}
                    onClose={this.onClose}
                    visible={this.state.visible}
                    getContainer={false}
                    style={{ position: 'absolute' }}
                    contentWrapperStyle={{width:'320px'}}
                >
                    <HXOrderForm orderDetail={this.state.orderDetail} />
                </Drawer>
            </>
        );
    }
}

function fetchColorHexForOrderStatus(status) {
    if (status === "待付款") {
        return "#FFA500";
    } else if (status === "待发货" || status === "待收货") {
        return "#1E90FF";
    } else {
        return "#32CD32";
    }
}

function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  console.log(query);

  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
  }
  return(false);
}

export default LZHXOrderList;